import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Card, CardMeta, CardContent, CardDescription, CardHeader, Input, Image, Form, FormField, FormGroup, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ReactPlayer from "react-player";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './index.scss'
import { connect } from 'react-redux';
import Lithiumion from '../../../assets/images/new-images/Lithiumion.png';
import Solar from '../../../assets/images/new-images/Solar.png';
import OpticalFiber from '../../../assets/images/new-images/OpticalFiber.png';
import GreenHydrogen from '../../../assets/images/new-images/GreenHydrogen.png';
import CarbonFiber from '../../../assets/images/new-images/CarbonFiber.png';
import ValueChain from '../../../assets/images/new-images/value-chain.png';
import UVECuring from '../../../assets/images/new-images/UVECuring.jpg';
import Semiconductor from '../../../assets/images/new-images/Semiconductor.jpg';
import AdditiveManufacturing from '../../../assets/images/new-images/AdditiveManufacturing.jpg';
import MapImg from '../../../assets/images/new-images/map.png';
import WeareBG from '../../../assets/images/new-images/weare-bg.jpg';
import userAvatar from '../../../assets/images/new-images/user-avatar.png';
import CallbackBG from '../../../assets/images/new-images/callback.jpg';
import SalesEcosystem from '../../../assets/images/new-images/SalesEcosystem.jpg';
import MappesNetwork from '../../../assets/images/new-images/MappesNetwork.jpg';
import HandsonTechnologySupport from '../../../assets/images/new-images/HandsonTechnologySupport.jpg';
/* support images */
import Installationsupport from '../../../assets/images/new-images/installationsupport.jpg';
import Logistics from '../../../assets/images/new-images/logistics.jpg';
import Troubleshooting from '../../../assets/images/new-images/troubleshooting.jpg';
import Maintenance from '../../../assets/images/new-images/maintenance.jpg';
import OncallSupport from '../../../assets/images/new-images/oncall-support.jpg';
import LocalSupport from '../../../assets/images/new-images/local-support.jpg';

/* support images */

/* company images  */
import company1 from '../../../assets/images/new-images/company1.png';
import company2 from '../../../assets/images/new-images/company2.png';
import company3 from '../../../assets/images/new-images/company3.png';
import company4 from '../../../assets/images/new-images/company4.png';
import company5 from '../../../assets/images/new-images/company5.png';
import company6 from '../../../assets/images/new-images/company6.png';
import company7 from '../../../assets/images/new-images/company7.png';
import company8 from '../../../assets/images/new-images/company8.png';
import company9 from '../../../assets/images/new-images/company9.png';
import company10 from '../../../assets/images/new-images/company10.png';
import company11 from '../../../assets/images/new-images/company11.png';
import company12 from '../../../assets/images/new-images/company12.png';
import company13 from '../../../assets/images/new-images/company13.png';
/* company images  */

import MediaQuery from 'react-responsive'

import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { formatIsoMilisecondOnlyTime, formatIsoMilisecondsWithoutTime, getDay, formatIsoMiliseconds, replaceSpaceInName, feedTimeAgo, month_names_short, number_formatter } from '../../../common/helperMethods';
import default_image from '../../../assets/images/add-event-default.png'
import { NewInviteUser } from '../../common/newInviteUser';
import WorldMap from './map';
import { emailRegex } from '../../../common/constants';
import SEO from '../../../components/seo/SEO';;

const HomePage = (props) => {
  const history = useHistory();
  let default_form_data = {
    full_name: '',
    company_name: '',
    email: '',
    contact: '',
  }

  let default_err_data = {
    full_name_error: '',
    company_name_error: '',
    email_error: '',
    email_id_invalid: '',
    contact_error: '',
  }

  const [tabs, setTabs] = useState('tab1')

  const [NetworkSliderSlidesData, setNetworkSliderSlidesData] = useState([]);
  const [CustomerSaysSlidesData, setCustomerSaysSlidesData] = useState([]);
  const [eventsData, seteventData] = useState([]);
  const [blogsData, setblogData] = useState([]);
  const [supporstData, setsupporstData] = useState([]);
  const [IndustriesData, setIndustriesData] = useState([]);

  const [form_data, setform_data] = useState(default_form_data);
  const [errors, set_errors] = useState(default_err_data);

  const [isFormValid, setisFormValid] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [applications, setapplications] = useState([]);
  const [prod_info, setprod_info] = useState([]);
  const [applicationsCount, setapplicationsCount] = useState(0);
  const [default_industry, setdefault_industry] = useState('')
  const [trendingData, setTrendingData] = useState([]);

  const [muted, setmuted] = useState(false)
  const [volume, setvolume] = useState(0.25)

  const handleValidation = (field, value) => {
    let error_field = field + '_error';
    setisFormValid(true);
    if (value !== '' && value !== undefined && value !== null && value !== false && value !== true) {
      value = value.replace(/^\s+|\s+$/gm, '')
    }

    if (value === '' || value === undefined || value === null) {
      errors[error_field] = true
      set_errors(errors)
    } else {
      errors[field + '_error'] = false

      if (field == 'email') {
        if (emailRegex.test(value.trim())) {
          errors['email_id_invalid'] = false;
        } else {
          errors['email_id_invalid'] = true;
        }
      }
      set_errors({ ...errors })
    }
  }

  const handleInputChange = (event) => {

    let current_value = event.target.value;

    if (current_value === '' || current_value === undefined || current_value === null) {
      current_value = '';
    }

    form_data[event.target.name] = current_value

    setform_data({ ...form_data });

    // validations 
    handleValidation(event.target.name, current_value);
  }

  useEffect(() => {

    const { auth } = props;
    if (auth) {
      history.push('/networkFeed/global')
    }

    localStorage.removeItem('email')
    localStorage.removeItem('user_data')

    if (location.pathname == '/buyers') {

      setTabs('tab2')

    }

    //  setLoading(true)

    axios.get(`${BASE_URL}/api/v2/testimonials/list`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length < 4) {
        data.push(data[1])
      }

      setCustomerSaysSlidesData(data)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.get(`${BASE_URL}/api/post/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setNetworkSliderSlidesData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.get(`${BASE_URL}/api/events/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      data.rows.forEach(item => {
        item.eventStartDate = isNaN(item.startDate) ? item.startDate : formatIsoMilisecondsWithoutTime(+item.startDate);
        item.eventStarTime = (item.startDate) ? formatIsoMilisecondOnlyTime(+item.startDate) : '';
        item.eventStartDay = getDay(+item.startDate);
        item.eventEndDate = isNaN(item.endDate) ? item.endDate : formatIsoMilisecondsWithoutTime(+item.endDate);
        item.eventEndTime = (item.endDate) ? formatIsoMilisecondOnlyTime(+item.endDate) : '';
        item.eventEndDay = getDay(+item.endDate);
        item.EventDate = new Date(parseInt(item.startDate)).getDate()
        item.EventMonth = month_names_short[new Date(parseInt(item.endDate)).getMonth()];
        item.eventStartDate = (item.eventStartDate != 'Invalid Date') ? item.eventStartDate : '';
        item.eventEndDate = (item.eventEndDate != 'Invalid Date') ? item.eventEndDate : '';

        item.eventStarTime = (item.eventStarTime != 'Invalid Date') ? item.eventStarTime : '';
        item.eventEndTime = (item.eventEndTime != 'Invalid Date') ? item.eventEndTime : '';

      })

      seteventData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.get(`${BASE_URL}/api/blogs/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setblogData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })

    // if (localStorage.getItem('industry_data') == 'undefined' || localStorage.getItem('industry_data') == undefined) {
    axios.get(`${BASE_URL}/api/v2/industries/get`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      let ddindex = 0;
      if (data.length > 0) {
        for (let index in data) {
          data[index]['image'] = '';
          data[index]['link'] = '';
          data[index]['Active'] = false;

          if (data[index]['product']['id'] == "SkW9l-VnJRsG") {
            data[index]['image'] = OpticalFiber;
            data[index]['link'] = 'ecosystem/optical-fiber';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "HJpXxbE2yRjG") {
            data[index]['image'] = UVECuring;
            data[index]['link'] = 'ecosystem/uv-eb-curing';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "S1mF5ohWK") {
            data[index]['image'] = GreenHydrogen;
            data[index]['link'] = 'ecosystem/green-hydrogen';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "HkqK_ZLfZvaDX") {
            data[index]['image'] = Semiconductor;
            data[index]['link'] = 'ecosystem/semiconductors';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "S1aD-N21Ciz") {
            data[index]['image'] = CarbonFiber;
            data[index]['link'] = 'ecosystem/carbon-fiber';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "rkxIVP6OrI") {
            data[index]['image'] = AdditiveManufacturing;
            data[index]['link'] = 'ecosystem/additive-manufacturing';
            data[index]['Active'] = false;
          }

          if (data[index]['product']['id'] == "ryh4YXLfWP6DX") {
            data[index]['image'] = Solar;
            ddindex = index
            data[index]['link'] = 'ecosystem/solar';
            data[index]['Active'] = true;
          }

          if (data[index]['product']['id'] == "SyG_WFgFX") {
            data[index]['image'] = Lithiumion;
            data[index]['link'] = 'ecosystem/lithium-ion';
            data[index]['Active'] = false;
          }
        }

        setIndustriesData(data)

        setdefault_industry(data[ddindex])
        localStorage.setItem('industry_data', JSON.stringify(data));

        setTimeout(() => {
          getProduct(data[ddindex])
        }, 1500);
      }
    }).finally(() => {
      //  setLoading(false)
    })
    /*  } else {
       let Industrydata = (localStorage.getItem('industry_data') != undefined) ? JSON.parse(localStorage.getItem('industry_data')) : []
       
       setIndustriesData(Industrydata)
     } */

    axios.get(`${BASE_URL}/api/v2/topics/trending/`, {
      "from": 0,
      "size": 5
    }).then((response) => {
      const { data } = response.data

      if (response.data.success == true) {
        if (data.length > 0) {
          setTrendingData(data)
        }
      }

    }).finally(() => {
      //  setLoading(false)
    })
  }, [])

  const getProduct = (item) => {
    if (item.product != undefined && item.product.id != undefined) {
      /*   history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`); */
      setapplications([])
      setprod_info([])
      setapplicationsCount(0)

      axios.get(`${BASE_URL}/api/v1/product/${item.product.id}`, {
        "from": 0,
        "size": 10
      }).then((response) => {
        const { Item } = response.data


        setprod_info(item)

        axios.get(`${BASE_URL}/api/v1/product/application/${item.product.id}`, {
          "from": 0,
          "size": 30
        }).then((response) => {
          const { Items, Count } = response.data
          setapplications(Items)
          setapplicationsCount(Count)

        }).finally(() => {
          //  setLoading(false)
        })

      }).finally(() => {
        //  setLoading(false)
      })
    }
  }

  const clientsSlide = [

    {
      id: 1,
      image: company2,
    },
    {
      id: 2,
      image: company3,
    },
    {
      id: 3,
      image: company4,
    },
    {
      id: 4,
      image: company5,
    },
    {
      id: 5,
      image: company6,
    },
    {
      id: 6,
      image: company7,
    },
    {
      id: 7,
      image: company8,
    },

    {
      id: 8,
      image: company9,
    },
    {
      id: 9,
      image: company10,
    },
    {
      id: 10,
      image: company11,
    },
    {
      id: 11,
      image: company12,
    },
    {
      id: 12,
      image: company13,
    },
  ]

  const supportData = [
    {
      id: 1,
      image: Installationsupport,
      title: 'Explore the full value chain of your industry'
    },
    {
      id: 2,
      image: Logistics,
      title: 'Insights into new customers, industries, and applications'
    },
    {
      id: 3,
      image: Troubleshooting,
      title: 'Strategic intelligence to guide expansion decisions'
    },
    {
      id: 4,
      image: Maintenance,
      title: 'Curated introductions and networking opportunities'
    },
    {
      id: 5,
      image: OncallSupport,
      title: 'Leverage intelligence that compounds over time'
    },
    {
      id: 6,
      image: LocalSupport,
      title: 'All the fragmented information in one place'
    },
  ]

  const gotoEvents = () => {
    history.push('/event-list');
  }

  const event_details = (id, name) => {
    history.push(`/events/${replaceSpaceInName(name)}/${id}`);
  }

  const gotoBlogs = () => {
    history.push('/articles');
  }

  const gotoCompany = (item) => {
    if (item.name != undefined && item.id != undefined) {

      history.push(`/company/${replaceSpaceInName(item.name)}/${item.id}`);
    }
  }

  const gotoProduct = (item) => {
    if (item.name != undefined && item.id != undefined) {
      history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`);
    }
  }


  const gotoProductPage = (link) => {
    if (link != '' && link != undefined) {

      history.push(`${link}`);
    }

  }

  const contact_us = () => {
    history.push('/contact-us');
  }

  const gotoValueChain = () => {
    history.push('/value-chain');
  }

  const gotoSpecificValueChain = (industry) => {
    localStorage.setItem('industry_name', industry.name)
    setTimeout(() => {
      history.push('/value-chain');
    }, 200);
  }

  const render_slider = (eventdata) => {
    const { image, eventName } = eventdata || {};
    if (image != undefined) {
      if (Array.isArray(image) && image.length > 0) {
        return (
          <img src={image[0]} className='w-100' alt={eventName} title={eventName} onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = default_image;
          }} />
        )
      } else if (!Array.isArray(image)) {
        return (
          <img src={image} alt={eventName} className='w-100' title={eventName} onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = default_image;
          }} />
        )
      } else {
        return (
          <img src={default_image} alt={eventName} className='w-100' title={eventName} />
        )
      }
    } else {
      return (
        <img src={default_image} className='w-100' alt={eventName} title={eventName} />
      )
    }
  }

  const contact_us_submit = () => {
    setisFormValid(true)
    for (var error in errors) {
      if (errors[error] === '') {
        errors[error] = true;
        set_errors({ ...errors })
        setisFormValid(false)
      } else {
        if (errors[error] === true) {
          setisFormValid(false)
        }
      }
    }

    setTimeout(() => {
      if (isFormValid) {
        try {
          let payload = {
            "type": "product",
            "document": {
              "name": form_data.full_name,
              "company_name": form_data.company_name,
              "email": form_data.email,
              "contact": form_data.contact,
              "comment": '',
              "services": []
            }
          }

          axios.post(`${BASE_URL}/api/v2/mappes/inquiry`, payload).then((response) => {

            const { data, message } = response.data;
            if (data != undefined && message.length > 0) {
              if (message[0]['type'] == 'success') {
                // setMessage(message[0]['message'])
                setMessage(`We've received your inquiry and our team will get in touch with you shortly.`)

                setTimeout(() => {
                  setform_data(default_form_data)
                  set_errors(default_err_data)
                  setErrorMessage('')

                }, 1500);

                setTimeout(() => {
                  setMessage('')
                }, 3500);
              } else {
                setErrorMessage('Unable to submit your query, please try again ')
              }
            } else {
              setErrorMessage('Unable to submit your query, please try again ')
            }
          }).finally(() => {
            //  setLoading(false)
          })

        } catch (error) {

          setErrorMessage('Unable to submit your query, please try again ')
        }
      }
    }, 300);
  }

  const gotofeed = (data) => {
    if (data.type == 'article') {
      history.push(`/article/${replaceSpaceInName(data.title)}/${data.id}`);
    } else {

      history.push(`/feed/post/${data.id}`);
    }
  }

  const change_link_tab = (value) => {
    if (value == 'tab1') {
      history.push(`/`);
    }

    if (value == 'tab2') {
      history.push(`/buyers`);
    }
  }

  const render_trending = (slide) => {
    if (slide.name != undefined && slide.count != undefined) {
      return (
        <li className='cursor-pointer' onClick={() => gotoProduct(slide)}>
          #{slide.name}
          {slide.count != '0' &&
            <div className='right-col'> {number_formatter(slide.count)}
              <SvgIcon name='eye-icon' viewbox="0 0 10 7" />
            </div>
          }
        </li>
      )
    }
  }

  const handleVolumeChange = e => {
    // this.setState({ volume: parseFloat(e.target.value), last_volume: parseFloat(e.target.value) })
    setvolume(parseFloat(e.target.value))
  }

  const mutePlayer = () => {
    let mute = false;
    let volume = 0;
    if (muted == true) {
      mute = false;
      // volume = last_volume;
    } else {
      mute = true;
      volume = 0;
    }
    setmuted(mute)
  }

  const render_user_avatar = (postdata) => {
    const { user, user_name } = postdata || {};
    if (user != undefined && user.image != undefined) {
      return (
        <Image
          floated='left' size='mini'
          src={user.image}
          alt={user_name}
          className='profile_img'
        />

      )
    } else {
      return (
        <Image
          floated='left' size='mini'
          src={userAvatar}
          alt={user_name}
          className='profile_img'
        />
      )
    }
  }

  return (
    <>
      <SEO key="homepage-seo"
        robots="index, follow"
        canonicalUrl="/"
        alternateLink="/"
        pageType={'homepage'}

      />
      <Header />
      <div className='homepage-view'>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <SvgIcon className='banner-logo' name='mappes-logo' viewbox='0 0 136 16' />
              <div className='banner-row'>
                <h2>Mapping the World’s Deep-Tech <br />Value Chains
                  <div className={'sub-heading'}>Turn ecosystem intelligence into growth opportunities.</div>
                </h2>

                {/* <div className='email-col'>
                  <Input placeholder='Enter Business Email' />
                  <Button primary>Join Mappes</Button>
                </div> */}
                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
        <section className='technologies-section'>
          <h1 className='main-heading mb-4'>
            Explore Emerging Industries & Their <span>Entire Value Chain</span>
          </h1>
          <Swiper
            spaceBetween={10}
            keyboard={true}
            modules={[Navigation]}
            navigation={true}
            direction={"horizontal"}
            speed={700}
            breakpoints={{
              320: { slidesPerView: 2.2 },
              640: { slidesPerView: 2.8 },
              1024: { slidesPerView: 3 },
              1300: { slidesPerView: 4.5 },
            }}
          >
            {IndustriesData.length > 0 &&
              IndustriesData.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <div className="slide-item cursor-pointer" onClick={() => gotoProductPage(slide.link)}>
                    <div className="slide-text slider-text">
                      <h4 className="cursor-pointer" >
                        {slide.name}
                      </h4>
                      <p>{slide.text}</p>
                    </div>
                    <img src={slide.image} alt={`Slide ${slide.id}`} />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </section>
        <section className='buysuptab-section'>
          <div className='tabs-row'>
            <button className={tabs == 'tab1' ? 'active' : ''} onClick={() => change_link_tab('tab1')}>Technology Discovery</button>
            <button className={tabs == 'tab2' ? 'active' : ''} onClick={() => change_link_tab('tab2')}>Market Expansion</button>
          </div>
        </section>
        {tabs == 'tab2' &&
          <section className='clients-section'>
            <div className='mappes-container'>
              <h1 className='main-heading text-center mb-4'>
                Expand Into New Markets with <span>Ecosystem Intelligence</span>
              </h1>
              <Swiper
                spaceBetween={0}
                loop={true}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 5 },
                  1300: { slidesPerView: 8 },
                }}
              >
                {clientsSlide.length > 0 &&
                  clientsSlide.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <div className="slide-item">
                        <img src={slide.image} alt={`Slide ${slide.id}`} />
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
              <div className='text-center mt-2'>
                <Button primary onClick={() => contact_us()}>Contact us now</Button>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab2' &&
          <section className='mappesoffer-section'>
            <div className='mappes-container'>
              <div className='mappesoffer-card'>
                <h1 className='main-heading text-left mb-4'>
                  What <span>Mappes.io</span> offers
                </h1>
                <div className='mappesoffer-list'>
                  <div className='mappesoffer-item'>
                    <img src={SalesEcosystem} alt='' />
                    <h4>Ecosystem Intelligence</h4>
                  </div>
                  <div className='mappesoffer-item'>
                    <img src={MappesNetwork} alt='' />
                    <h4>New Market Insights</h4>
                  </div>
                  <div className='mappesoffer-item'>
                    <img src={HandsonTechnologySupport} alt='' />
                    <h4>Stakeholder Connections</h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab2' &&
          <section className='deliversuccess-section'>
            <div className='mappes-container'>
              <h1 className='main-heading text-left mb-4'>
                Why Global Companies Choose <span>Mappes</span>
              </h1>
              <div className='deliversuccess-list'>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    1
                  </div>
                  <div className='right-text'>
                    To Understand <b>Complex Value Chains</b>
                  </div>
                </div>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    2
                  </div>
                  <div className='right-text'>
                    <b>Discover</b> Opportunities Faster
                  </div>
                </div>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    3
                  </div>
                  <div className='right-text'>
                    Showcase <b>Expertise</b> &amp; <b>Technology</b>
                  </div>
                </div>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    4
                  </div>
                  <div className='right-text'>
                    Connect with <b>Relevant Stakeholders</b>
                  </div>
                </div>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    5
                  </div>
                  <div className='right-text'>
                    <b>Leverage Intelligence</b> for Strategic Decisions
                  </div>
                </div>
                <div className='deliversuccess-item'>
                  <div className='left-num'>
                    6
                  </div>
                  <div className='right-text'>
                    <b>Track Trends</b> and <b>Market Signals</b>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab2' &&
          <section className='video-section'>
            <div className='mappes-container'>
              <h1 className='main-heading'>
                Connect & Network with <span>Key Market Players</span>
              </h1>
              <div className='video-card'>
                <div style={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                    <ReactPlayer
                      url='https://youtu.be/lBa8p-lN48M'
                      playing={false}
                      loop={true}
                      fullscreen={false}
                      playIcon={false}
                      width="100%"
                      muted={muted}
                      height="100%"
                      volume={volume}
                      controls={true}
                      config={{
                        youtube: {
                          playerVars: {
                            controls: 0,
                            modestbranding: 1,
                            rel: 0,
                            showinfo: 0,
                          },
                        },
                      }}
                    />
                    <div className='action-row'>
                      <div className='volume-player'>
                        <button onClick={() => mutePlayer()}>{muted ? <SvgIcon name='mute-icon' viewbox='0 0 23 16' /> : <SvgIcon name='volume-icon' viewbox='0 0 21.998 16.969' />}</button>
                        <input type='range' min={0} max={1} step='any' value={volume} onChange={handleVolumeChange} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center mt-3'>
                <Button primary onClick={() => contact_us()}>Contact us</Button>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab2' &&
          <section className='salessupport-section'>
            <div className='mappes-container'>
              <h1 className='main-heading text-left'>Your Market Expansion Engine</h1>
              <MediaQuery minWidth={767}>
                <div className="salessupport-grid">
                  {supportData.length > 0 && supportData.map(item =>
                    <div key={item.id} className="salessupport-card">
                      <img src={item.image} alt="Installation support" />
                      <h3>{item.title}</h3>
                    </div>
                  )}
                </div>
              </MediaQuery>
              <MediaQuery maxWidth={768}>
                <div className="salessupport-grid">
                  <Swiper
                    modules={[Pagination]}
                    spaceBetween={20}
                    loop={true}
                    pagination={{ clickable: true }}
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      640: { slidesPerView: 2 },
                      1024: { slidesPerView: 3 },
                    }}
                  >
                    {supportData.length > 0 &&
                      supportData.map((item) => (
                        <SwiperSlide key={item.id}>
                          <div className="salessupport-card">
                            <img src={item.image} alt="Installation support" />
                            <h3>{item.title}</h3>
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </MediaQuery>
            </div>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='video-section'>
            <div className='mappes-container'>
              <h1 className='main-heading'>
                Discover technologies and manufacturers across emerging value chains
              </h1>
              <div className='video-card'>
                <div style={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                    <ReactPlayer
                      url='https://youtu.be/woitq_mk-P4'
                      playing={false}
                      loop={true}
                      fullscreen={false}
                      playIcon={false}
                      width="100%"
                      muted={muted}
                      height="100%"
                      volume={volume}
                      controls={false}
                    />
                    <div className='action-row'>
                      <div className='volume-player'>
                        <button onClick={() => mutePlayer()}>{muted ? <SvgIcon name='mute-icon' viewbox='0 0 23 16' /> : <SvgIcon name='volume-icon' viewbox='0 0 21.998 16.969' />}</button>
                        <input type='range' min={0} max={1} step='any' value={volume} onChange={handleVolumeChange} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center mt-3'>
                <Link to='/contact-us'><Button primary>Contact us</Button></Link>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='valuechain-section'>
            <div className='mappes-container'>
              <div className='valuechain-row'>
                <div className='valuechain-col1'>
                  <h1 className='main-heading'>
                    Leverage the <span>value chain</span> to unlock new opportunities.
                  </h1>
                  <div className='value-chain-filter'>
                    {IndustriesData.length > 0 && IndustriesData.map(slide => (
                      <button onClick={() => gotoSpecificValueChain(slide)} className={slide.Active == true ? 'active' : ''} > {slide.name}</button>
                    ))}
                  </div>
                  <MediaQuery minWidth={577}>
                    <div className='text-left mt-5'>
                      <Link to='/value-chain'><Button primary onClick={() => gotoValueChain()}>Go to Value Chain</Button></Link>
                    </div>
                  </MediaQuery>
                </div>
                <div className='valuechain-col2'>
                  <div className=''>
                    <img src={ValueChain} alt='' width={'100%'} />
                  </div>
                  {/* <div className='valuechain-inner'>
                    <NodeLinkGraph applications={applications}
                      applicationsCount={applicationsCount}
                      product={prod_info}
                      from={'new'}
                      width={'100%'}
                      height='440px'
                    />
                  </div> */}
                </div>
                <MediaQuery maxWidth={576}>
                  <div className='text-left mt-4'>
                    <Link to='/value-chain'><Button className='w-100' primary onClick={() => gotoValueChain()}>Go to Value Chain</Button></Link>
                  </div>
                </MediaQuery>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='access-section'>
            <div className='mappes-container'>
              <div className='accessmap-row'>
                <div className='map-col'>
                  <img className='map-img' src={MapImg} alt='' />
                  <WorldMap />
                </div>
                <div className='right-col'>
                  <h1 className='main-heading'>
                    Discover Technologies & Network With <span>Global Manufacturers</span>
                  </h1>
                  <ul >
                    <li>India</li>
                    <li>China</li>
                    <li>United Kingdom</li>
                    <li>Germany</li>
                    <li>South Korea</li>
                    <li>Taiwan</li>
                    <li>& many more</li>
                  </ul>
                  <Link to='/otp-login' ><Button primary >Sign Up for Access</Button></Link>
                </div>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='clients-section'>
            <div className='mappes-container'>
              <h1 className='main-heading text-left mb-4'>
                <span>Trusted</span> by industry leaders
              </h1>
            </div>
            <Swiper
              spaceBetween={0}
              loop={true}
              breakpoints={{
                320: { slidesPerView: 3 },
                640: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
                1300: { slidesPerView: 8 },
              }}
            >
              {clientsSlide.length > 0 &&
                clientsSlide.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <div className="slide-item">
                      <img src={slide.image} alt={`Slide ${slide.id}`} />
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='weare-section'>
            <div className='mappes-container'>
              <div className='weare-card'>
                <img className='weare-bg' src={WeareBG} alt='' />
                <div className='card-left'>
                  <h1>Navigate Complex Deep-Tech Ecosystems:</h1>
                </div>
                <div className='card-right'>
                  <ul>
                    <li><span>1</span>Explore global manufacturing ecosystems and value chains</li>
                    <li><span>2</span> Access curated intelligence across technologies, applications, and markets</li>
                    <li><span>3</span>Network with stakeholders across the entire value chain</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        }
        {tabs == 'tab1' &&
          <section className='mappesnetwork-section'>
            <div className='mappes-container'>
              <div className='mappesnetwork-left'>
                <h1 className='main-heading'>
                  Join the Global Ecosystem for <br />
                  <span>Advanced Manufacturing</span>
                </h1>
                <ul>
                  {trendingData.length > 0 && trendingData.map(slide =>
                    /* slide.name && (<li className='cursor-pointer' onClick={() => gotoProduct(slide)}>#{slide.name}  <div className='right-col'>{slide.count} <SvgIcon name='eye-icon' viewbox="0 0 10 7" /></div> </li>) */
                    render_trending(slide)
                  )}
                </ul>
                <Link to={'/otp-login'}> <Button primary>Sign Up for a Personalized Feed</Button></Link>
              </div>
              <div className='mappesnetwork-right'>
                <Swiper
                  spaceBetween={0}
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                  loop={false}
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 2.3 },
                  }}
                >
                  {NetworkSliderSlidesData.length > 0 &&
                    NetworkSliderSlidesData.map((slide) => (
                      <SwiperSlide key={slide.id}>
                        <div className="slide-item cursor-pointer" onClick={() => gotofeed(slide)}>
                          <Card  >
                            <CardContent>
                              {/* {slide.userphoto ? (
                                <Image floated='left' size='mini' src={slide.userphoto} />
                              ) : (
                                <Image floated='left' size='mini' src={userAvatar} />
                              )} */}
                              {render_user_avatar(slide)}
                              <CardHeader>{slide.user ? slide.user.displayName : ''}</CardHeader>
                              <CardMeta>
                                <span className='time-col'>{feedTimeAgo(slide.added)}</span>
                                {slide.user?.company && <><span> | </span><span className='company-name'>{slide.user.company}</span></>}
                              </CardMeta>
                              <CardDescription
                                dangerouslySetInnerHTML={{
                                  __html: slide.text.replace(/<\/?[^>]+(>|$)/g, "").substr(0, 250),
                                }}
                              />
                            </CardContent>

                            <CardContent extra className='card-action'>
                              <div className='left-actions'>
                                <ul>
                                  <li><SvgIcon name='thumbsup-icon' viewbox="0 0 18 19" />{slide.like_count}</li>
                                  <li><SvgIcon name='comment-icon' viewbox="0 0 18 18" />{slide.comment_count}</li>
                                  <li><SvgIcon name='share-icon' viewbox="0 0 18 19" /></li>
                                </ul>
                              </div>
                              <div className='right-actions'>
                                <SvgIcon name='cube-icon' viewbox="0 0 18 20" />
                              </div>
                            </CardContent>
                          </Card>
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </section>
        }

        <section className='blog-section'>
          <div className='mappes-container'>
            <div className='blog-header'>
              <h1 className='main-heading'>Insights on <span>Emerging Technologies</span> Driving Industrial Change</h1>
              <Button className='viewall-btn' onClick={() => gotoBlogs()}>View All <SvgIcon name='chevron-right' viewbox="0 0 8 14" /></Button>
            </div>

            <MediaQuery minWidth={992}>
              <div className={blogsData.length > 0 ? ` blogs-row  blog-section-${blogsData.length}` : 'blogs-row'}  >
                {blogsData.length > 0 && blogsData.map(item => (
                  <div key={item.id} className={` card col${item.id}`}>
                    <div className='upper-row cursor-pointer' onClick={() => gotofeed(item)}>
                      <h2>{item.title}</h2>
                      <p dangerouslySetInnerHTML={{ __html: item.text.replace(/<\/?[^>]+(>|$)/g, "").replace(/<\/?[^>]+(>|$)/g, "").substr(0, 250) }}></p>
                    </div>
                    {item.tagged_product_details != undefined && item.tagged_product_details.length > 0 &&
                      <div className="tags">
                        {item.tagged_product_details.map(tagged_data => (

                          <span> <Link to={`/product/${replaceSpaceInName(tagged_data.name)}/${tagged_data.id}`} key={tagged_data.id}>{tagged_data.name}</Link></span>
                        ))}
                      </div>
                    }
                  </div>
                ))}
              </div>
            </MediaQuery>

            <MediaQuery maxWidth={991}>
              <div className='blogs-row'>
                <Swiper
                  modules={[Pagination]}
                  spaceBetween={20}
                  pagination={{ clickable: true }}
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                >
                  {blogsData.length > 0 &&
                    blogsData.map((item) => (
                      <SwiperSlide key={item.id}>
                        <div className="card">
                          <div className='cursor-pointer' onClick={() => gotofeed(item)}>
                            <h2>{item.title}</h2>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: item.text.replace(/<\/?[^>]+(>|$)/g, '').substr(0, 250),
                              }}
                            ></p>
                            <a href="#">read more</a>
                          </div>

                          {item.tagged_product_details && item.tagged_product_details.length > 0 && (
                            <div className="tags">
                              {item.tagged_product_details.map((tagged_data) => (
                                <span key={tagged_data.id}>
                                  <Link to={`/product/${replaceSpaceInName(tagged_data.name)}/${tagged_data.id}`}>
                                    {tagged_data.name}
                                  </Link>
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </MediaQuery>

          </div>
        </section>
        <section className='callback-section'>
          <div className='mappes-container'>
            <div className='callback-card'>
              <img className='callback-bg' src={CallbackBG} alt='' />
              <div className='left-col'>
                {location.pathname == '/buyers' ? <>Expanding into New Markets? <br />Contact Us Now.</> : <>Looking for a supplier? Reach out to us.</>}
              </div>
              <div className='right-col'>
                <Form>
                  <FormGroup widths='equal'>
                    <FormField
                      className="required"
                      control={Input}
                      placeholder='Your name*'
                      name="full_name"
                      id="full_name"
                      onChange={handleInputChange}
                      value={form_data.full_name}
                    />
                    {errors.full_name_error === true ? (<span className='text-danger'> Name is required </span>) : ''}
                    <FormField
                      className="required"
                      control={Input}
                      placeholder='Your company*'
                      name="company_name"
                      id="company_name"
                      onChange={handleInputChange}
                      value={form_data.company_name}
                    />
                    {errors.company_name_error === true ? (<span className='text-danger'> Company is required </span>) : ''}

                  </FormGroup>
                  <FormGroup widths='equal'>
                    <FormField
                      className="required"
                      control={Input}
                      placeholder='Enter email*'
                      name="email"
                      id="email"
                      onChange={handleInputChange}
                      value={form_data.email}
                    />
                    {errors.email_error === true ? (<span className='text-danger'> Email address is required </span>) : ''}
                    <br />
                    {errors.email_id_invalid === true && errors.email_error !== true ? (<span className='text-danger'> Email address is not valid Email </span>) : ''}
                    <FormField
                      className="required"
                      control={Input}
                      placeholder='Enter phone number*'
                      name="contact"
                      id="contact"
                      onChange={handleInputChange}
                      value={form_data.contact}
                    />
                    {errors.contact_error === true ? (<span className='text-danger'> Contact is required </span>) : ''}
                  </FormGroup>
                  <div className='text-right'>
                    <Button primary onClick={() => contact_us_submit()}>Request Call back</Button>
                  </div>
                  {errorMessage != '' ? <span>
                    <div className="text-left mt-2 mb-2">
                      <Message className="reduce-msg-padding" compact visible error content={errorMessage} />
                    </div>
                  </span> : <span></span>
                  }

                  {message != "" &&
                    <span>
                      <div className="text-left mt-2 mb-2">
                        <Message className="reduce-msg-padding" compact visible success content={message} />
                      </div>
                    </span>
                  }
                </Form>
              </div>
            </div>
          </div>
        </section>
        {tabs == 'tab1' &&
          <section className='stayconnect-section'>
            <div className='mappes-container'>
              <div className='stayconnect-header'>
                <h1 className='main-heading'><span>Stay connected </span> to events in your industry</h1>
                <Button className='viewall-btn' onClick={() => gotoEvents()} >View All <SvgIcon name='chevron-right' viewbox="0 0 8 14" /></Button>
              </div>
              <div className='stayconnet-row'>
                <Swiper
                  spaceBetween={8}
                  modules={[Pagination]}
                  loop={true}
                  pagination={{ clickable: true }}
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1300: { slidesPerView: 3.6 },
                  }}
                >
                  {eventsData.length > 0 &&
                    eventsData.map((slide) => (
                      <SwiperSlide key={slide.id}>
                        <div className="slide-item">
                          <div className="stayconnect-card cursor-pointer" onClick={() => event_details(slide.id, slide.eventName)}>
                            <div className="card-upper">
                              <div className="date-col">
                                <h3>{slide.EventDate}</h3>
                                <p>{slide.EventMonth}</p>
                              </div>
                              {render_slider(slide)}
                            </div>

                            <div className="card-bottom">
                              <div
                                className="event-name cursor-pointer"
                                onClick={() => event_details(slide.id, slide.eventName)}
                              >
                                {slide.eventName}
                              </div>
                              {/* <div className='event-desc'>{slide.details.replace(/<\/?[^>]+(>|$)/g, "").substr(0, 200)}</div> */}

                              <div className="info-list">
                                <div className="list-item">
                                  <div className="icons">
                                    <SvgIcon name="date-icon" viewbox="0 0 18 20" />
                                  </div>
                                  {slide.eventStartDay} | {slide.eventStartDate} - {slide.eventEndDate}
                                </div>

                                <div className="list-item">
                                  <div className="icons">
                                    <SvgIcon name="time-icon" viewbox="0 0 19 19" />
                                  </div>
                                  {slide.eventStarTime} - {slide.eventEndTime}
                                </div>

                                {/* <div className='list-item'><div className='icons'><SvgIcon name='map-icon' viewbox="0 0 16 20" /></div> {slide.area} {slide.city} {slide.pincode} {slide.country} {slide.location}  </div> */}

                                <div className="list-item">
                                  {slide.eventType === 'online' && (
                                    <>
                                      <div className="icons">
                                        <SvgIcon name="video-icon" viewbox="0 0 20.332 13.667" />
                                      </div>
                                      Online
                                    </>
                                  )}
                                  {slide.eventType === 'offline' && (
                                    <>
                                      <div className="icons">
                                        <SvgIcon name="map-icon" viewbox="0 0 16 20" />
                                      </div>
                                      {slide.location}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="card-action">
                              <div className="left-action">
                                <Button onClick={() => event_details(slide.id, slide.eventName)}> I'm Attending</Button>
                              </div>
                              <div className="right-action">
                                <Button onClick={() => event_details(slide.id, slide.eventName)}>
                                  <SvgIcon name="shares-icon" viewbox="0 0 18 15" />
                                </Button>
                                <Button onClick={() => event_details(slide.id, slide.eventName)}>
                                  <SvgIcon name="tag-icon" viewbox="0 0 15 18" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </section>
        }
        <section className='customersays-section'>
          <div className='mappes-container'>
            <div className='customersays-left'>
              <h1 className='main-heading'>
                What <span>our</span> <br />
                <span>customers</span> say
              </h1>
            </div>
            <div className='customersays-right'>
              <Swiper
                spaceBetween={20}
                modules={[Pagination]}
                pagination={{ clickable: true }}
                loop={true}
                initialSlide={0}
                keyboard={true}
                direction={"horizontal"}
                mousewheel={{
                  releaseOnEdges: true,
                }}
                speed={700}
                breakpoints={{
                  320: { slidesPerView: 1.3 },
                  576: { slidesPerView: 1.3 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 2.5 },
                }}
              >
                {CustomerSaysSlidesData.length > 0 &&
                  CustomerSaysSlidesData.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <div key={slide.id} className="slide-item">
                        <Card>
                          <CardContent>
                            <SvgIcon className="quoteicon" name="quotes-icon" viewbox="0 0 82 64" />
                            <CardHeader>{slide.user_name}</CardHeader>
                            <CardMeta>
                              <span className="time-col">{slide.designation}</span> | {' '}
                              <span className="company-name">{slide.company}</span>
                            </CardMeta>
                            <CardDescription>{slide.comment}</CardDescription>
                          </CardContent>
                        </Card>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Access Intelligence Across Advanced Technology Ecosystems</h2>

                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  return { auth };
}

export default connect(mapStateToProps)(HomePage);
